import type { IconData } from '@stacksjs/iconify-core'

export const batteryF: IconData = {
  "body": "<g fill=\"currentColor\"><path d=\"M2 0h15a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2\"/><path d=\"M18.5 3h.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-.5A1.5 1.5 0 0 1 17 7.5v-3A1.5 1.5 0 0 1 18.5 3\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default batteryF
